import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1752.768,221.108706 C1532.64565,0.986352941 1174.28329,0.986352941 954.160941,221.108706 L115.572706,1059.69694 C-38.4790588,1213.86165 -38.4790588,1464.59106 115.572706,1618.64282 C265.106824,1768.064 525.549176,1767.95106 674.631529,1618.64282 L1433.37035,860.016941 C1521.35153,771.922824 1521.35153,628.600471 1433.37035,540.506353 C1345.05035,452.299294 1201.728,452.525176 1113.85976,540.506353 L475.064471,1179.41459 L554.913882,1259.264 L1193.70918,620.355765 C1237.64329,576.534588 1309.248,576.421647 1353.52094,620.355765 C1397.45506,664.402824 1397.45506,736.233412 1353.52094,780.167529 L594.782118,1538.79341 C484.551529,1648.91106 305.426824,1648.79812 195.422118,1538.79341 C85.3044706,1428.67576 85.4174118,1249.55106 195.422118,1139.54635 L1034.01035,300.958118 C1209.97271,124.995765 1496.39153,124.769882 1672.91859,300.958118 C1848.99388,477.146353 1848.99388,763.791059 1672.91859,939.866353 L874.311529,1738.58635 L954.160941,1818.43576 L1752.768,1019.71576 C1972.77741,799.593412 1972.77741,441.231059 1752.768,221.108706",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPaperclipLine = /*#__PURE__*/function (_Component) {
  _inherits(IconPaperclipLine, _Component);

  var _super = _createSuper(IconPaperclipLine);

  function IconPaperclipLine() {
    _classCallCheck(this, IconPaperclipLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconPaperclipLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPaperclip",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPaperclipLine.displayName = "IconPaperclipLine";
  return IconPaperclipLine;
}(Component);

IconPaperclipLine.glyphName = 'paperclip';
IconPaperclipLine.variant = 'Line';
IconPaperclipLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPaperclipLine;
export { IconPaperclipLine };